import KeyTakeaway from "@/components/ui/key-takeaway";

export default function Introduction() {
  return (
    <section className="mb-16">
      <div className="border-l-4 border-[#E74C3C] px-6 py-4 bg-[#ECF0F1] rounded mb-8">
        <p className="text-lg italic">
          Peptides represent one of the most promising frontiers in medicine today. 
          Operating as the body's natural signaling molecules, they offer precise 
          biological effects with minimal side effects. From diabetes treatment to 
          weight management and beyond, peptides are poised to transform how we 
          approach health and aging.
        </p>
      </div>
      
      <p className="text-lg leading-relaxed mb-6">
        In this feature, we'll explore the fascinating world of peptides—from their 
        basic biological function to their emerging applications in modern medicine. 
        You'll discover why these tiny protein fragments are capturing the attention 
        of physicians, researchers, and health-conscious individuals alike.
      </p>
      
      <KeyTakeaway>
        Peptides occupy a unique middle ground in therapeutics: larger than small-molecule 
        drugs but smaller than antibodies. This "Goldilocks zone" allows them to engage 
        targets too large for conventional drugs while avoiding the complexity and cost 
        of full-sized biologics.
      </KeyTakeaway>
    </section>
  );
}
